export const SET_GIFT_CARD_DATA = "SET_GIFT_CARD_DATA";
export const SET_CURRENT_COLOR = "SET_CURRENT_COLOR";

export function setGiftCardData(data) {
  return function (dispatch) {
    dispatch({
      type: SET_GIFT_CARD_DATA,
      payload: {
        data,
      },
    });
  };
}

export function setCurrentColor(colorCode, colors) {
  return function (dispatch) {
    dispatch({
      type: SET_CURRENT_COLOR,
      payload: {
        colorCode,
        colors,
      },
    });
  };
}
